import { StamhoofdFilterDecoder } from "./FilteredRequest";
export class PropertyFilter {
    constructor(enabledWhen, requiredWhen) {
        /**
         * Enabled when...
         * null = always enabled
         */
        this.enabledWhen = null;
        /**
         * If enabled, whether it is required
         * null = always skippable
         * empty filter = always required
         */
        this.requiredWhen = null;
        this.enabledWhen = enabledWhen;
        this.requiredWhen = requiredWhen;
    }
    static createDefault() {
        return new PropertyFilter(null, {});
    }
    isEnabled(object) {
        if (this.enabledWhen === null) {
            return true;
        }
        return object.doesMatchFilter(this.enabledWhen);
    }
    isRequired(object) {
        if (this.requiredWhen === null) {
            return false;
        }
        return object.doesMatchFilter(this.requiredWhen);
    }
    encode(context) {
        return {
            enabledWhen: this.enabledWhen,
            requiredWhen: this.requiredWhen
        };
    }
    static decode(data) {
        if (data.context.version < 251) {
            console.error('PropertyFilter: legacy filter detected - this is not implemented yet. Possible data loss.');
            return PropertyFilter.createDefault();
        }
        return new PropertyFilter(data.field("enabledWhen").nullable(StamhoofdFilterDecoder), data.field("requiredWhen").nullable(StamhoofdFilterDecoder));
    }
}
//# sourceMappingURL=PropertyFilter.js.map